import { createSlice } from "@reduxjs/toolkit";
import { SOCIALMEDIA_WIDGET } from "../../../constants/reducer_names";
import callChatService from "../../../base/service/chatService";
import { GetItemFromStorage } from "../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../custom_hooks/localStorageKeys";



const initialState: any = {
    socialmediaInvite: false,
    inviteData: {}
} as any;

const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
const socialmediaWidgetSlice = createSlice({
    name: SOCIALMEDIA_WIDGET,
    initialState,
    reducers: {
        setSocialmediaInvite: (state, { payload }) => {
            state.socialmediaInvite = payload
        },
        setInviteData: (state, { payload }) => {
            if (Object.keys(payload)?.length > 0 && Object.keys(state.inviteData).length > 0 && payload.sessionId !== state.inviteData?.sessionId) {
                callChatService.io.emit("socialMediaAgentDeclineRequest", {
                    sessionId: payload?.sessionId,
                    channelType: payload?.channelType,
                    responseMessage: "agent is declined",
                    userId: LoginCcaasUserDetails.UserID,
                    ext: LoginCcaasUserDetails.ext,
                    domainId: LoginCcaasUserDetails.domainId,
                    UserName: LoginCcaasUserDetails.UserName,
                    customerNumber: payload?.customerNumber,
                    agentNumber: payload?.agentNumber,
                    calledPersonDetails: payload?.calledPersonDetails,
                    historyId: payload?.historyId,
                    allAgent: payload?.allAgent,
                    WhatsappDurationHistoryId:payload?.WhatsappDurationHistoryId ?? null
                });
            } else {
                state.inviteData = payload
            }
        },
    }
});


export const SocialmediaWidgetActions = socialmediaWidgetSlice.actions;
export default socialmediaWidgetSlice.reducer;



